export default __webpack_public_path__ + "static/media/Ballroll_00170.c0669689.png";